import { Injectable } from '@angular/core';
//import { logEvent } from "firebase/analytics";
import "firebase/analytics";
import { analytics } from 'src/app/app.module';

@Injectable({
  providedIn: 'root'
})
export class FirebaseAnalyticsService {

  constructor() { }

  postEvent(event_name: any, objData?: any) {
    // console.log(event_name,objData);
    analytics.logEvent(event_name, objData);
    //logEvent(analytics, event_name, objData);
  }
}
